/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".fileTypeIcon_9a419b77{font-size:20px;overflow:visible}.fileTypeIconColumn_9a419b77{overflow:visible}.fileTypeIconHeader_9a419b77 .ms-DetailsHeader-cellName{text-overflow:initial;overflow:visible}.fileTypeIconHeader_9a419b77 .fileTypeIcon_9a419b77{font-size:16px}\n"}]);
export const fileTypeIcon = "fileTypeIcon_9a419b77";
export const fileTypeIconColumn = "fileTypeIconColumn_9a419b77";
export const fileTypeIconHeader = "fileTypeIconHeader_9a419b77";